import { createFileRoute } from '@tanstack/react-router';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { InvitePage } from '../screens/mobile/InvitePage';

/**
 * A Paige Mobile invite on a phone that did not open it in the app (docs/engineering/mobile-capture.md,
 * 4.2). No sign-in: the invited person has no Paige account and never will; the token is in the fragment.
 */
export const Route = createFileRoute('/m/invite')({
  component: () => (
    <HushedFrame>
      <InvitePage />
    </HushedFrame>
  ),
});
